import avatarModule from '../avatarModule';

function avatarItems(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarItems
  };
}

avatarModule.directive('avatarItems', avatarItems);

export default avatarItems;
